import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: false,
  productsInReservationsCart: [],
  newProfileData: {},
  submittedReservationId: null,
  storeInformation: {},
};

const addItemToReservationsCart = (cartItems, addingItem) => {
  let isItemInCartChanged = false;
  const correctCardItems = cartItems.map((cartItem) => {
    const { pimSkuId, currentQty = 0 } = cartItem;
    if (pimSkuId === addingItem.pimSkuId) {
      isItemInCartChanged = true;

      return { ...cartItem, currentQty: currentQty + 1 };
    }

    return cartItem;
  });

  return isItemInCartChanged ? correctCardItems : [...cartItems, { ...addingItem, currentQty: 1 }];
};

export const reservationsCheckout = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.SEARCH_PRODUCT_FOR_RESERVATIONS_LOADING:
    case actionTypes.GET_STORE_INFORMATION_LOADING:
    case actionTypes.SUBMIT_RESERVATION_ORDER_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.SEARCH_PRODUCT_FOR_RESERVATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        productsInReservationsCart: addItemToReservationsCart(state.productsInReservationsCart, payload),
      };
    case actionTypes.SEARCH_PRODUCT_FOR_RESERVATIONS_ERROR:
    case actionTypes.GET_STORE_INFORMATION_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case actionTypes.CLEAR_RESERVATIONS_CART:
      return {
        ...state,
        productsInReservationsCart: [],
      };
    case actionTypes.ADD_RESERVATIONS_ITEM_QTY:
      return {
        ...state,
        productsInReservationsCart: state.productsInReservationsCart.map((item) => {
          const { pimSkuId, currentQty = 1 } = item;
          if (pimSkuId === payload) {
            return { ...item, currentQty: currentQty + 1 };
          }
          return item;
        }),
      };
    case actionTypes.REMOVE_RESERVATIONS_ITEM_QTY:
      return {
        ...state,
        productsInReservationsCart: state.productsInReservationsCart.map((item) => {
          const { pimSkuId, currentQty } = item;
          if (pimSkuId === payload) {
            const correctQty = currentQty - 1;
            return { ...item, currentQty: correctQty };
          }
          return item;
        }),
      };
    case actionTypes.REMOVE_RESERVATIONS_CART_ITEM:
      return {
        ...state,
        productsInReservationsCart: state.productsInReservationsCart.filter(({ pimSkuId }) => pimSkuId !== payload),
      };
    case actionTypes.SUBMIT_RESERVATION_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        submittedReservationId: payload,
      };
    case actionTypes.SUBMIT_RESERVATION_ORDER_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case actionTypes.SET_RESERVATIONS_PROFILE_DATA:
      return {
        ...state,
        newProfileData: payload,
      };
    case actionTypes.CLEAR_RESERVATIONS_PROFILE_DATA:
      return {
        ...state,
        newProfileData: {},
      };
    case actionTypes.GET_STORE_INFORMATION_SUCCESS:
      return {
        ...state,
        storeInformation: payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default reservationsCheckout;
